import {
    CONSENT__GET__START,
    CONSENT__GET__SUCCESS,
    CONSENT__GET__FAILURE,
    CONSENT__GET__RESET,
    CONSENT__SET__START,
    CONSENT__SET__SUCCESS,
    CONSENT__SET__FAILURE,
} from './actions';

const initialState = {
    data: {},
    isLoading: false,
    isLoaded: false,
    error: null,
};
export default function BRANDReducer(state = initialState, action = {}) {
    switch (action.type) {
        case CONSENT__GET__START: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: null,
            };
        }
        case CONSENT__GET__SUCCESS: {
            return {
                ...state,
                data: action.data,
                isLoading: false,
                isLoaded: true,
                error: null,
            };
        }
        case CONSENT__GET__FAILURE: {
            return {
                ...state,
                data: {},
                isLoading: false,
                isLoaded: false,
                error: action.error,
            };
        }
        case CONSENT__GET__RESET: {
            return {
                ...state,
                data: {},
                isLoading: false,
                isLoaded: false,
                error: action.error,
            };
        }
        case CONSENT__SET__START: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: null,
            };
        }
        case CONSENT__SET__SUCCESS: {
            return {
                ...state,
                data: action.data,
                isLoading: false,
                isLoaded: true,
                error: null,
            };
        }
        case CONSENT__SET__FAILURE: {
            return {
                ...state,
                data: {},
                isLoading: false,
                isLoaded: false,
                error: action.error,
            };
        }
        default: {
            return state;
        }
    }
}
